import { render, staticRenderFns } from "./createApprovalUserRole.vue?vue&type=template&id=f3981386&scoped=true"
import script from "./createApprovalUserRole.vue?vue&type=script&lang=js"
export * from "./createApprovalUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3981386",
  null
  
)

export default component.exports